import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicAcademicYear({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8.74 2.6l6.33 1.86a1.24 1.24 0 010 2.4L8.74 8.7a2.6 2.6 0 01-1.48 0L2.5 7.31v4.32a1 1 0 01.4.68v.12a1 1 0 11-1.6-.8V6.96l-.37-.1a1.24 1.24 0 010-2.4L7.26 2.6c.48-.15 1-.15 1.48 0zM12 8.19c.41 0 .75.34.75.75v2.5c0 .2-.08.39-.22.53-1.8 1.8-7.27 1.8-9.06 0a.75.75 0 01-.22-.53v-2.5a.75.75 0 011.5 0v2.15c1.38.97 5.12.97 6.5 0V8.93c0-.41.34-.75.75-.75zM7.68 4.02l-5.6 1.64 5.6 1.64c.19.05.41.06.64 0l5.6-1.64-5.6-1.64a1.16 1.16 0 00-.64 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicAcademicYear.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicAcademicYear.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicAcademicYear svgRef={ref} {...props} />
));
export default ForwardRef;
